<template>
  <div class="scrape_container">
    <div class="scrape_box">
      <div class="scrape_area" id="scrape_area">
        <scratch-card 
            v-if="isScrape"
            elementId="scratch" 
            :width= canvasWidth 
            :height= canvasHeight 
            :moveRadius="15" 
            :ratio="0.35"
            :startCallback="startCallback" 
            :clearCallback="clearCallbackUp"
            coverColor ='gray'
            :coverImg="require('@/assets/images/raffle/ggz_area.png')"
            :result="result"
            style="position: absolute;top: 0;left: 0;top: 50%;left: 50%;transform: translate(-50%, -50%);">
        </scratch-card>
      </div>
      <div class="scrape_tips_box">
        <img :src="require('@/assets/images/raffle/ggl_notice_bg.png')" alt="">
        <div class="scrape_tips">您有<span class="remain_times" v-text="remainTime"></span>次抽奖机会</div>
      </div>
      <div class="scrape_info_box">
        <!-- 我的奖品 -->
        <div class="my_prize_box">
          <div class="my_prize_title">我的奖品</div>
          <div class="prize_table_title">
            <span class="time">中奖时间</span>
            <span class="name">奖品</span>
            <span class="btn_span">兑奖</span>
          </div>
          <div class="prize_content">
            <ul class="prize_list">
              <li class="prize_item" v-for="(item,index) in myPrizeList" :key="index">
                <span class="time" v-text="item.drawTime.substring(0,10)"></span>
                <span class="name" v-text="item.awardName"></span>
                <span class="btn_span" v-if="item.luckerStatus==0">
                  <span class="btn btn_recipient" v-if="item.addressee.length>0 && item.expressPhone.length>0 && item.expressAddress.length>0" @click="recipientInfo(item)">查看</span>
                  <span class="btn" @click="showAcceptHandler(item)" v-else>兑奖</span>
                </span>
                <span class="btn_span" v-else-if="item.luckerStatus==1">
                  <span class="btn btn_dis">已兑</span>
                </span>
                <span class="btn_span" v-else><span class="btn btn_dis">放弃</span></span>
              </li>
            </ul>
          </div>
        </div>
        <!-- 抽奖规则 -->
        <div class="rules_box">
          <div class="rules_title">【抽奖规则】：</div>
          <div class="rule_content" v-html="detail.details" v-if="!!detail"></div>
        </div>
        <!-- 奖项设置 -->
        <div class="awards_box">
          <div class="awards_title">【奖项设置】：</div>
          <div class="award_content">
            <ul class="award_list" v-if="!!awards && awards.length>0">
              <li class="award_item" v-for="(item,index) in awards" :key="index">
                <div class="award_title"><span v-text="index+1"></span>）<span v-text="item.awardName"></span></div>
                <div class="award_img">
                  <img :src="item.resourceUrl" alt="">
                </div>
                <div class="award_description" v-text="item.details"></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 兑奖 -->
    <van-popup :style="{ width: '80%', height: 'auto', overflow: 'hidden', backgroundColor: '#fff9d9', borderRadius: '10px' }" v-model="showAccept">
      <div class="dj_box">
        <van-tabs class="tabbar" @click="onDJTabClick" :line-width="'60px'">
          <van-tab title="现场兑奖"></van-tab>
          <van-tab title="邮寄奖品"></van-tab>
        </van-tabs>
        <div class="dj_content">
          <div class="mail_address_box" v-if="isMail">
            <p class="inputInfoTitle">请输入收件信息</p>
            <div class="recipientName">
              <label>收件人：</label>
              <input class="nameInput" autocomplete="off" v-model="curPrize.addressee" type="text" placeholder="请输入收件人姓名">
            </div>
            <div class="phoneDiv">
              <label>手机号：</label>
              <input class="phoneInput" autocomplete="off" v-model="curPrize.expressPhone" type="text" placeholder="请输入手机号号码">
            </div>
            <div class="recipientAddress">
              <label>收件地址：</label>
              <input class="addressInput" autocomplete="off" v-model="curPrize.expressAddress" type="text" placeholder="请输入收件地址">
            </div>
            <span class="submitTijiao" @click="acceptPrizeByMail">确定</span>
          </div>
          <div class="prize_code_box" v-else>
            <p class="inputInfoTitle">请输入兑奖码</p>
            <div class="prizeCode">
              <label>兑奖码：</label>
              <input class="codeInput" type="text" v-model="prizeCode" placeholder="请输入兑奖码">
            </div>
            <div class="tips">注：兑奖码可与主办方沟通获得！</div>
            <span class="submitTijiao" @click="acceptPrizeByCode">确定</span>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepClone, testMobilePhone } from "@/utils";
import raffleApi from "@/api/apis/raffle.js";
import ScratchCard from 'lzy-scratch-card'
export default {
  name: "Scrape",
  props: {
    detailInfo: {
      type: Object,
      default: null,
    },
    freeFlag: {
      type: Number,
      default: 0,
    },
    awards: {
      type: Array,
      default: [],
    },
  },
  components: {
    ScratchCard,
  },
  watch: {
    detailInfo: {
      handler(newValue, oldValue) {
        if (!!newValue) {
          this.detail = deepClone(newValue);
          this.raffleId = this.detail.id;
          if (this.freeFlag == 1) {
            this.remainTime = 1;
          } else {
            this.getRaffleTimes();
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  data() {
    return {
      detail: null, // 详情
      raffleId: 0, // 抽奖Id
      remainTime: 0, // 抽奖剩余次数
      showMyPrize: false, // 显示我的奖品
      myPrizeList: [], // 我的中奖记录
      showAccept: false, // 显示兑奖弹窗
      isMail: false, // 是否邮寄，默认现场兑奖
      curPrize: null, // 当前的兑奖数据
      prizeCode: "", // 兑奖码
      result: ``,//遮罩层下面的页面（html）注：以html标签字符串的样式写
      isScrape : false,
      failedMsg: ['谢谢参与', '再接再厉', '不要灰心', '祝您好运', '加油加油'], // 未中奖提示语
      failedMsgIndex : 0,
      prizeName : '',  //中奖礼物名称
    };
  },
  methods: {
    /* 获取剩余抽奖次数 */
    getRaffleTimes() {
      var _this = this;
      raffleApi
        .getDrawRaffleTimes({ drawRaffleId: _this.raffleId, memberId: _this.userInfo.id })
        .then((res) => {
          if (res.suc == 1) {
            _this.remainTime = res.data.surplusTimes;
          } else {
            _this.remainTime = 0;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 获取我的及时抽奖中奖奖品 */
    getListAwardLogsByMemberId() {
      var _this = this;
      raffleApi
        .listAwardLogsByMemberId({
          code: _this.nodeCode,
          memberId: _this.userInfo.id,
          pageNo: 0,
          pageSize: 100,
        })
        .then((res) => {
          if (res.suc == 1) {
            _this.myPrizeList = res.data.list;
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 抽奖 */
    doRaffle() {
      var _this = this;
      if (_this.remainTime <= 0) {
        return;
      } else {
        var parmas = {
          drawRaffleId: _this.raffleId,
          memberId: _this.userInfo.id,
          surplusTimes: _this.remainTime,
          freeFlag: _this.freeFlag,
        }
        raffleApi
          .doDrawRaffle(parmas)
          .then((res) => {
            if (res.suc == 1 && res.data.result == 1) {
              _this.resultHandler("恭喜您，获得" + res.data.awardName);
              _this.prizeName = res.data.awardName;
              //_this.$dialog.alert({ message: "恭喜您，获得" + res.data.awardName });
            } else {
              _this.failedMsgIndex = Math.floor(Math.random() * _this.failedMsg.length);
              _this.resultHandler(_this.failedMsg[_this.failedMsgIndex]);
              _this.prizeName = '';
            }
            if (_this.freeFlag == 1) {
              _this.remainTime = 0;
            } else {
              _this.getRaffleTimes();
            }
          })
          .catch((err) => {
            // _this.$toast({
            //   message: "接口调用出错",
            //   position: "center",
            // });
            _this.failedMsgIndex = Math.floor(Math.random() * _this.failedMsg.length);
            _this.resultHandler(_this.failedMsg[i]);
            _this.prizeName = '';
          });
      }
    },
    /* 现场兑奖/邮寄兑奖 tab切换 */
    onDJTabClick(index) {
      if (index == 0) {
        this.isMail = false;
      } else {
        this.isMail = true;
      }
    },
    /* 显示兑奖弹窗 */
    showAcceptHandler(data) {
      this.showAccept = true;
      this.curPrize = data;
    },
    /* 查看邮寄地址 */
    recipientInfo(data) {
      this.showAccept = true;
      this.curPrize = data;
    },
    /* 兑奖码兑奖 */
    acceptPrizeByCode() {
      var _this = this;
      var code = _this.curPrize.drawTime.substring(11, 19).replace(/:/g, '');
      if (_this.prizeCode == '') {
        _this.$toast({
          message: "请输入兑奖码!",
          position: "center",
        });
        return;
      } else if (code != _this.prizeCode) {
        _this.$toast({
          message: "您输入的兑奖码不正确",
          position: "center",
        });
        return;
      } else {
        raffleApi
          .acceptPrize({ awardLogsId: _this.curPrize.id })
          .then((res) => {
            if (res.suc == 1) {
              _this.$dialog
                .alert({ message: "兑奖成功！" })
                .then(() => {
                  _this.showAccept = false;
                  _this.prizeCode == '';
                  _this.curPrize.luckerStatus = 1;
                });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /* 邮寄奖品兑奖 */
    acceptPrizeByMail() {
      var _this = this;
      if (_this.curPrize.addressee == '') {
        _this.$toast({
          message: "请输入收件人!",
          position: "center",
        });
        return;
      } else if (_this.curPrize.expressPhone == '') {
        _this.$toast({
          message: "您输入手机号!",
          position: "center",
        });
        return;
      } else if (_this.curPrize.expressAddress == '') {
        _this.$toast({
          message: "请输入收件地址!",
          position: "center",
        });
        return;
      } else if (!testMobilePhone(_this.curPrize.expressPhone)) {
        _this.$toast({
          message: "请填写正确的手机号码!",
          position: "center",
        });
        return;
      } else {
        raffleApi
          .awardSaveExpressInfo({
            awardLogsId: _this.curPrize.id,
            addressee: _this.curPrize.addressee,
            expressPhone: _this.curPrize.expressPhone,
            expressAddress: _this.curPrize.expressAddress,
          })
          .then((res) => {
            if (res.suc == 1) {
              _this.$dialog
                .alert({ message: "保存成功！" })
                .then(() => {
                  _this.showAccept = false;
                });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      }
    },
    /***  刮刮乐方法 start  ***/
    initCanvas() {
        let scrape_area = document.getElementById('scrape_area');
        this.clientWidth = document.documentElement.clientWidth,
        this.canvasWidth = scrape_area.offsetWidth + 'px',
        this.canvasHeight = scrape_area.offsetHeight+ 'px';
        this.isScrape = true;
    },
    startCallback(){
      //开始刮时的回调函数
      console.log('开始');
      this.doRaffle();
    },
    clearCallbackUp(){
      //刮刮乐刮层全部清除后的回调函数
      if(this.prizeName!= ''){ //中奖
        this.$dialog.alert({ message: this.prizeName }).then(() => {
          this.oneMoreHandler();
        });
      }else{
        this.$dialog.alert({ message: this.failedMsg[this.failedMsgIndex] }).then(() => {
          this.oneMoreHandler();
        });
      }
    },
    oneMoreHandler(){
      if(this.remainTime <=0){
        setTimeout(() => {
          this.$dialog.alert({ message: '您的抽奖次数不足！'});
        }, 1000);
      }else{
        setTimeout(() => {
          this.$dialog.confirm({
            message: '是否继续抽奖',
          })
          .then(() => {
            this.isScrape = false;
            this.$nextTick(()=>{
              this.isScrape = true;
            })
          })
          .catch(() => {
            // on cancel
          });
        }, 1000);
      }
    },
    resultHandler(str){
      this.result = `<p style="font-size: 24px;font-weight: bold;background-image: linear-gradient(135deg,#ff7700e3,#ffc900f5);transform: translate(-50%, -50%);background-clip: text;-webkit-background-clip: text; color: transparent;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);text-align: center;">${str}</p>`
    },
    //未中奖提示
    failedHandler(){
      var i = Math.floor(Math.random() * this.failedMsg.length);
      this.$dialog.alert({ message: this.failedMsg[i] })
      .then(() => {
        this.resultHandler(this.failedMsg[i]);
      });
    }
    /***  刮刮乐方法 end  ***/
  },
  created() {
    if (!!this.userInfo) {
      this.getListAwardLogsByMemberId();
    }
  },
  mounted() {
    if (!!this.detailInfo) {
      this.initCanvas();
      this.detail = deepClone(this.detailInfo);
      this.raffleId = this.detail.id;
      if (this.freeFlag == 1) {
        this.remainTime = 1;
      } else {
        this.getRaffleTimes();
      }
    }
  }
};
</script>
<style scoped lang="scss">
.scrape_container {
  width: 100%;
  height: 100%;
  padding: 0px;
  background-color: #f0f0f0;
  overflow-x: hidden;
  overflow-y: auto;
  .scrape_box {
    position: relative;
    padding-top: 40px;
    /* 刮刮乐区域 */
    .scrape_area {
      width: calc(100% - 80px);
      height: 0;
      padding-bottom: calc(56.25% - 45px);
      // background-color: gray;
      margin: 0 40px 40px;
      border-radius: 10px;
      position: relative;

      /deep/ .result{
        // background: url(~@/assets/images/default_pic_16_9.png) no-repeat;
        background-color: white;
      }
    }
    /* 提示语 */
    .scrape_tips_box {
      position: relative;
      width: calc(100% - 80px);
      background-color: #df3435;
      margin: 40px;
      img {
        display: block;
        width: 100%;
      }
      .scrape_tips {
        position: absolute;
        left: 20%;
        top: 50%;
        transform: translateY(-62%);
        color: #fff;
        font-size: 18px;
        .remain_times {
          color: #ffe21f;
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }
    .scrape_info_box {
      position: relative;
      width: 100%;
      min-height: 56.25vw;
      padding: 24px;
      margin-top: 60px;
      background-color: #df3435;
      &::before {
        position: absolute;
        left: 0;
        top: -2vw;
        width: 100%;
        height: 4vw;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% auto;
        background-image: url(~@/assets/images/raffle/ggl_info_bg.png);
        content: "";
      }
      /* 我的奖品 */
      .my_prize_box {
        padding: 15px;
        background-color: #fff9d9;
        .my_prize_title {
          padding-bottom: 10px;
          color: #ff8000;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
        }
        .prize_table_title {
          padding: 0 15px 10px;
          font-weight: bold;
          .time {
            display: inline-block;
            width: 100px;
            text-align: center;
          }
          .name {
            display: inline-block;
            width: 40%;
            text-align: center;
          }
          .btn_span {
            display: inline-block;
            width: calc(60% - 100px);
            text-align: center;
          }
        }
        .prize_content {
          width: 100%;
          min-height: 200px;
          padding: 0 15px 15px;
          .prize_list {
            .prize_item {
              line-height: 32px;
              font-size: 14px;
              .time {
                display: inline-block;
                width: 100px;
                text-align: center;
              }
              .name {
                display: inline-block;
                width: 40%;
                text-align: center;
              }
              .btn_span {
                display: inline-block;
                width: calc(60% - 100px);
                text-align: center;
                .btn {
                  padding: 5px 10px;
                  background: orange;
                  color: #fff;
                  font-size: 12px;
                  border-radius: 3px;
                  &.btn_dis {
                    background: gray;
                    opacity: 0.5;
                  }
                  &.btn_recipient {
                    background: orangered;
                  }
                }
              }
            }
          }
        }
      }
      /* 抽奖规则 */
      .rules_box {
        padding: 15px;
        background-color: #fff9d9;
        margin-top: 20px;
        color: #000;
        .rules_title {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
        }
        .rule_content {
          width: 100%;
          word-break: normal;
          color: #646464;
          line-height: 25px;
          /deep/img {
            display: block;
            max-width: 100%;
            height: auto;
            margin: 5px auto;
          }
        }
      }
      .awards_box {
        padding: 15px;
        background-color: #fff9d9;
        margin-top: 20px;
        color: #000;
        .awards_title {
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
        }
        .award_content {
          width: 100%;
          .award_list {
            .award_item {
              margin-bottom: 10px;
              .award_title {
                margin-bottom: 5px;
                line-height: 24px;
                color: #646464;
                font-weight: bolder;
              }
              .award_img {
                padding: 0 10px;
                margin-bottom: 5px;
                img {
                  display: block;
                  max-width: 100%;
                }
              }
              .award_description {
                line-height: 24px;
                padding: 0 10px;
              }
            }
          }
        }
      }
    }
  }
  /* 兑奖弹窗 */
  .dj_box {
    .tabbar {
      /deep/.van-tabs__nav {
        background: #fff9d9;
      }
    }
    .dj_content {
      padding: 5px 15px 15px;
      .prize_code_box,
      .mail_address_box {
        width: 100%;
        height: auto;
        .inputInfoTitle {
          width: 100%;
          height: 40px;
          line-height: 40px;
          color: #ff8000;
          text-align: center;
          font-weight: bold;
          font-size: 20px;
          // font-family: "Microsoft YaHei";
        }
        .prizeCode,
        .recipientName,
        .phoneDiv {
          height: 40px;
          line-height: 40px;
          label {
            width: 64px;
            font-size: 16px;
          }
          .codeInput,
          .nameInput,
          .phoneInput,
          .addressInput {
            width: 70%;
            height: 32px;
            outline: none;
            border: none;
            // font-family: "Microsoft YaHei";
            text-indent: 5px;
            background: transparent;
            border-bottom: 1px solid #000;
            color: #000;
          }
        }
        .recipientAddress {
          height: 40px;
          line-height: 40px;
          label {
            width: 80px;
            font-size: 16px;
          }
          .addressInput {
            width: calc(70% - 16px);
            height: 32px;
            outline: none;
            border: none;
            // font-family: "Microsoft YaHei";
            text-indent: 5px;
            background: transparent;
            border-bottom: 1px solid #000;
            color: #000;
          }
        }
        .tips {
          line-height: 40px;
          line-height: 40px;
          color: orangered;
          font-size: 13px;
        }
        .submitTijiao {
          display: block;
          width: 80%;
          height: 32px;
          line-height: 32px;
          background: #00c957;
          margin: 20px auto 0;
          color: #fff;
          text-align: center;
          font-size: 16px;
          // font-family: "Microsoft YaHei";
          -moz-border-radius: 2px;
          -webkit-border-radius: 2px;
          border-radius: 2px;
          cursor: pointer;
          outline: none;
        }
      }
    }
  }
}
</style>